// "Hridayaye Shivastishthatu": a father in silent jap at dawn → hold to be still → Shiva's signs appear in light → the father becomes Shiva in a blue aura → gangajal → the painting.
const FIG = { y: 1.3, s: 2.4 };
export const shiva = {
  slug: "hridayaye-shivastishthatu",
  duration: 32,
  captionTail: ["God was never distant. He sat beside me, like my father, in jap.", "Painted with gangajal, on Shivratri."],
  stages: [
    { id: "jap", at: 0, hint: "early morning, in jap" },
    { id: "still", at: 8.5, hint: "hold to be still" },
    { id: "presence", at: 9.5, hint: "his presence" },
    { id: "aura", at: 20.5, hint: "" },
  ],
  hold: { at: 9, need: 3, auto: 20 },
  touch: { kind: "press", from: 8.5, until: 9.1 },
  line: { text: "May Shiva reside in my heart.", from: 18.5, to: 31.5, pos: "low" },
  // only a deep, reverberant OM carries this journey from the very first second (no voice or chant, no tanpura, bells or damru, no music track)
  quiet: true,
  ambient: { scene: "silence", until: 99, then: [] },
  // the OM fades in gently with the father's jap, building as his presence gathers, fullest as he becomes Shiva, echoing into the emergence
  bed: { src: "/sounds/shiva/om-bed.mp3", gain: [[0, 0], [1.4, 0.01], [4, 0.1], [8.5, 0.13], [10, 0.2], [16, 0.36], [20, 0.52], [21.5, 0.68], [27, 0.64], [31, 0.34], [38, 0.14], [44, 0.05]] },
  look: { start: 0.0, lift: [0, 1], end: 0.0, yaw: [[0, 0.5], [5, 0], [32, 0]] },
  calm: { duration: 12, fade: [4, 8.5], line: [5.5, 11.5], backdrop: "shiva", pos: "low" },
  speed: [[0, 1], [32, 1]],
  figures: {
    appear: [0.5, 2.5],
    thread: [99, 99],
    fade: [28, 30.5],
    list: [
      { src: "/arcs/shiva/father.webp", th: 0, y: FIG.y, w: FIG.s, h: FIG.s, appear: [0.5, 2.5], fade: [20.5, 24], eye: 1 },
      { src: "/arcs/shiva/shiva.webp", th: 0, y: FIG.y, w: FIG.s, h: FIG.s, appear: [20.5, 24] },
    ],
  },
  figFrag: `
uniform sampler2D uFig;
uniform float uAppear, uFade, uT, uEye;
varying vec2 vUv;
void main(){
  vec4 c = texture2D(uFig, vUv);
  // the third eye opening in light, last of his signs
  float k = uEye * smoothstep(18.0, 19.5, uT);
  float eye = 1.0 - smoothstep(0.7, 1.0, length(vec2((vUv.x - 0.455) / 0.011, (vUv.y - 0.8) / 0.028)));
  c.rgb = mix(c.rgb, vec3(1.0, 0.93, 0.7), eye * k * c.a);
  float a = c.a * uAppear * (1.0 - uFade);
  if (a < 0.01) discard;
  gl_FragColor = vec4(c.rgb, a);
  #include <colorspace_fragment>
}`,
  frag: `
uniform sampler2D uMap;
uniform vec4 uCrop;
uniform float uT, uAspect, uTileH, uRadius, uCy, uSurface, uStill;
varying vec3 vPos;
${"__NOISE__"}
float hash2(vec2 p){ return fract(sin(dot(p, vec2(41.3, 289.1))) * 43758.5453); }
vec3 tap(vec2 uv){
  vec2 m = 1.0 - abs(1.0 - mod(uv, 2.0));
  return texture2D(uMap, mix(uCrop.xy, uCrop.zw, m)).rgb;
}
float seg(vec2 p, vec2 a, vec2 b){ vec2 pa = p - a, ba = b - a; float h = clamp(dot(pa, ba) / dot(ba, ba), 0.0, 1.0); return length(pa - ba * h); }
// lines drawn in light: a bright core and a soft glow
vec3 light(vec3 col, float d, float k){
  return col + vec3(1.0, 0.9, 0.65) * k * ((1.0 - smoothstep(0.012, 0.03, d)) * 0.9 + exp(-d * 16.0) * 0.35);
}
void main(){
  float n = snoise(vPos * 0.6) * 0.5 + 0.5;
  float n2 = snoise(vPos * 3.0 + 4.0) * 0.5 + 0.5;
  float th = atan(vPos.x, -vPos.z);
  float blue = smoothstep(22.5, 27.0, uT);
  float settle = smoothstep(26.5, 31.0, uT);
  vec3 col;
  vec2 local;
  // the aura's strokes: sweeping blues and greys with a touch of gold
  float sw = snoise(vec3(vPos.x * 0.5 + vPos.y * 0.9, vPos.y * 0.4, vPos.z * 0.5 + uT * 0.05)) * 0.5 + 0.5;
  vec3 aura = mix(mix(vec3(0.14, 0.24, 0.55), vec3(0.42, 0.58, 0.9), sw), vec3(0.62, 0.66, 0.72), smoothstep(0.7, 0.9, n2) * 0.6);
  aura += vec3(0.9, 0.7, 0.3) * smoothstep(0.93, 0.99, n2) * 0.5;
  if (uSurface < 0.5) {
    float X = th * uRadius;
    float y = vPos.y;
    col = mix(vec3(0.5, 0.4, 0.5), vec3(0.14, 0.15, 0.3), smoothstep(0.3, 5.0, y)) * (0.94 + 0.08 * n) + vec3(0.35, 0.2, 0.12) * (1.0 - smoothstep(0.0, 1.6, y)) * smoothstep(0.0, 8.0, uT);
    vec2 c = vec2(X, y - 1.45);
    float r = length(c * vec2(1.0, 0.8));
    // the breathing glow around him slows as you hold still
    float breath = 0.5 + 0.5 * sin(uT * mix(1.3, 0.45, uStill));
    col += vec3(0.5, 0.62, 1.0) * exp(-pow(r - 1.15 - 0.1 * breath, 2.0) * 4.0) * (0.25 + 0.2 * breath) * smoothstep(2.0, 4.0, uT);
    // a page of handwritten Nam jap filling line by line beside him
    vec2 pg = vec2(X - 2.55, y - 1.7);
    float page = step(abs(pg.x), 0.62) * step(abs(pg.y), 0.85);
    col = mix(col, vec3(0.97, 0.93, 0.84) * (0.95 + 0.05 * n2), page * smoothstep(0.5, 1.5, uT));
    float row = floor((0.75 - pg.y) / 0.13);
    float ry = 0.75 - (row + 0.5) * 0.13;
    float t0 = 1.0 + row * 0.6;
    float reach = -0.55 + 1.1 * clamp((uT - t0) / 0.55, 0.0, 1.0);
    float script = abs(pg.y - ry - 0.025 * sin(pg.x * 55.0 + row * 2.3) * sin(pg.x * 13.0 + row));
    float hand = (1.0 - smoothstep(0.004, 0.009, script)) + (1.0 - smoothstep(0.004, 0.008, abs(pg.y - ry - 0.035))) * step(0.5, fract(pg.x * 6.0 + row * 0.37)) * 0.8;
    col = mix(col, vec3(0.45, 0.12, 0.1), min(hand, 1.0) * page * step(row, 11.0) * step(0.0, row) * step(pg.x, reach) * step(-0.55, pg.x));
    // his presence: crescent, Ganga, serpent, trishul and damru, one by one in light
    vec2 m = vec2(X + 0.1, y - 2.75);
    float cres = abs(length(m) - 0.2);
    cres = max(cres, 0.03 - length(m - vec2(0.09, 0.06)) + 0.17);
    col = light(col, cres, smoothstep(10.0, 11.2, uT));
    float gd = 10.0;
    for (int i = 0; i < 10; i++){
      float s0 = float(i) / 10.0, s1 = float(i + 1) / 10.0;
      vec2 a = vec2(0.05 + s0 * 1.5, 2.7 + 0.55 * sin(s0 * 2.4) - s0 * s0 * 1.1);
      vec2 b = vec2(0.05 + s1 * 1.5, 2.7 + 0.55 * sin(s1 * 2.4) - s1 * s1 * 1.1);
      gd = min(gd, seg(vec2(X, y), a, b) - 0.01 * sin(uT * 4.0 + s0 * 20.0));
    }
    col = light(col, abs(gd), smoothstep(11.6, 12.8, uT));
    float sx = -1.3 + 0.13 * sin(y * 6.0 + uT * 0.8);
    float serp = abs(X - sx) + 10.0 * (step(y, 0.55) + step(2.15, y));
    serp = min(serp, abs(length(vec2(X - (-1.3 + 0.13 * sin(2.2 * 6.0 + uT * 0.8)), (y - 2.22) * 1.4)) - 0.07));
    col = light(col, serp, smoothstep(13.2, 14.4, uT));
    float tr = seg(vec2(X, y), vec2(1.35, 0.4), vec2(1.35, 3.15));
    for (int s = 0; s < 2; s++){
      float sg = float(s) * 2.0 - 1.0;
      tr = min(tr, seg(vec2(X, y), vec2(1.35, 2.72), vec2(1.35 + sg * 0.22, 2.75)));
      tr = min(tr, seg(vec2(X, y), vec2(1.35 + sg * 0.22, 2.75), vec2(1.35 + sg * 0.25, 3.05)));
    }
    col = light(col, tr, smoothstep(14.8, 16.0, uT));
    vec2 dm = vec2(X - 1.35, y - 2.28);
    float dam = abs(abs(dm.x) - (0.04 + 0.13 * abs(dm.y) / 0.15)) + 10.0 * step(0.15, abs(dm.y));
    dam = min(dam, abs(abs(dm.y) - 0.15) + 10.0 * step(0.17, abs(dm.x)));
    col = light(col, dam, smoothstep(16.4, 17.6, uT));
    // the blue aura expands to hold you
    float reachA = (uT - 22.5) * 2.2;
    col = mix(col, aura, blue * (1.0 - smoothstep(reachA - 1.2, reachA, r)));
    // gangajal drops falling
    vec2 dq = vec2(X * 3.0, y * 1.4 + uT * 2.4);
    vec2 dc = floor(dq);
    vec2 df = fract(dq) - 0.5;
    float drop = step(0.82, hash2(dc)) * (1.0 - smoothstep(0.8, 1.0, length(vec2(df.x / (0.06 * (1.0 + clamp(df.y / 0.2, -1.0, 1.0) * 0.8)), df.y / 0.2))));
    col = mix(col, vec3(0.85, 0.92, 1.0), drop * smoothstep(24.0, 25.0, uT) * (1.0 - smoothstep(29.0, 30.5, uT)) * 0.8);
    local = vec2(X, y - uCy);
  } else if (uSurface < 1.5) {
    col = mix(vec3(0.3, 0.26, 0.3), vec3(0.36, 0.31, 0.34), n);
    col = mix(col, aura * 0.85, blue * smoothstep(0.0, 1.0, (uT - 23.5) * 0.5));
    local = vPos.xz;
  } else {
    col = mix(vec3(0.12, 0.13, 0.26), aura, blue);
    local = vPos.xz;
  }
  vec2 tile = vec2(uTileH * uAspect, uTileH);
  vec3 paint = tap(local / tile + 0.5);
  float drip = uSurface < 0.5 ? (10.0 - vPos.y) / 10.0 : 0.5 + length(vPos.xz) / (uRadius * 3.0);
  col = mix(col, paint, smoothstep(0.0, 0.25, settle * 1.3 - drip * 0.6 - n * 0.25));
  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);
  #include <colorspace_fragment>
}`,
};
